import { render, staticRenderFns } from "./Koordinator.vue?vue&type=template&id=1528c851&"
import script from "./Koordinator.vue?vue&type=script&lang=js&"
export * from "./Koordinator.vue?vue&type=script&lang=js&"
import style0 from "./Koordinator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports